var htmlElClassList = document.querySelector('html').classList;

var showLaunchers = function() {
  showSmileIo();
  showEnchant();
}

var hideLaunchers = function() {
  hideSmileIo();
  hideEnchant();
}

var showSmileIo = function() {
  htmlElClassList.remove('hide-smile-io');
}

var hideSmileIo = function() {
  htmlElClassList.add('hide-smile-io');
}

var showEnchant = function() {
  htmlElClassList.remove('hide-enchant-messenger');
}

var hideEnchant = function() {
  htmlElClassList.add('hide-enchant-messenger');
}


// hide Smile.io if a modal is opened
document.addEventListener('modalOpen', function() {
  hideLaunchers();
});

// show Smile.io if a modal is closed
document.addEventListener('modalClose', function() {
  showLaunchers();
});

// hide Smile.io if a drawer is opened
document.addEventListener('drawerOpen', function() {
  hideLaunchers();
});

// show Smile.io if a drawer is closed
document.addEventListener('drawerClose', function() {
  showLaunchers();
});

/* initialize home-product-slider */
var homeProductSlider = document.querySelector('.home-product-slider');
if (homeProductSlider) {
  function isSmallerThan520px() {
    return window.matchMedia("(max-width: 520px)").matches;
  }

  function isSmallerThan768px() {
    return window.matchMedia("(max-width: 768px)").matches;
  }

  function getOptionsBasedOnWidth() {
    if (isSmallerThan520px()) {
      return {
        optionName: '<520', // custom option, ignored by Flickity
        adaptiveHeight: false,
        setGallerySize: true,
        freeScroll: false,
        contain: true,
        resize: true,
        prevNextButtons: false,
        pageDots: false
      };
    } else if (isSmallerThan768px()) {
      return {
        optionName: '<768',
        adaptiveHeight: false,
        setGallerySize: true,
        freeScroll: false,
        contain: true,
        resize: true,
        prevNextButtons: false,
        pageDots: false,
        groupCells: 2
      };
    } else {
      return {
        optionName: '>768',
        adaptiveHeight: false,
        setGallerySize: true,
        freeScroll: false,
        contain: true,
        resize: true,
        prevNextButtons: true,
        pageDots: false,
        groupCells: 4
      };
    }
  }

  var initHomeProductSlider = function() {
    function controlPrevNextButtons(indexSlide) {
      if (indexSlide === 0) {
        homeProductSlider.classList.add('at-start');
      } else if (indexSlide === (flickitySlider.slides.length - 1)) {
        homeProductSlider.classList.add('at-end');
      } else {
        homeProductSlider.classList.remove('at-start');
        homeProductSlider.classList.remove('at-end');
      }
    }

    var options = getOptionsBasedOnWidth();
    var flickitySlider = new Flickity(homeProductSlider, options);
    controlPrevNextButtons(0);

    // hide control buttons if at the first or last slide (takes groupCells into account)
    flickitySlider.on('select', controlPrevNextButtons);

    // Reset dimensions on resize
    window.on('resize', theme.utils.debounce(150, function() {
      flickitySlider.resize();

    /*
      This was an attempt to reinitialize Flickity at different breakpoints
      The code does work but there is a lot of jumping on the screen
      I tried to set a fixed height (height of the first div) and only switch it to auto
        after the elements are again visible but the ready Flickity event triggers before
        everything is shown on the screen, so the jumping wasn't prevented
      Idea: might use a timeout to restore the height value to auto, see implementation above
      Update: the "implementation above" was removed in favor of a CSS solution,
        see home-products.liquid, styling on .flickity-viewport
      That means, all the screen jumping on this implementation needs to be reevaluated
    */
    /*
      var newOptions = getOptionsBasedOnWidth();
      if (options.optionName === newOptions.optionName) {
        flickitySlider.resize();
      } else {
        // get the height of the first div
        var targetHeight = homeProductSlider.querySelector('.flickity-slider > div').offsetHeight;
        homeProductSlider.style.height = targetHeight + 'px';
        flickitySlider.destroy();

        options = newOptions;
        flickitySlider = new Flickity(homeProductSlider, Object.assign({}, newOptions, {
          on: {
            ready: function() {
              homeProductSlider.style.height = 'auto';
            }
          }
        }));
      }
    */
    }));
  }

  theme.initWhenVisible({
    element: homeProductSlider,
    callback: initHomeProductSlider.bind(this),
    threshold: 20
  });
}

theme.UpsellProduct = (function() {
  var status = {
    loading: false
  };

  var selectors = {
    upsellItem: '.upsell__item',
    acceptItem: 'button.upsell-accept',
    rejectItem: 'button.upsell-reject'
  };

  function UpsellProductForm(containerSelector) {
    this.containers = Array.from(document.querySelectorAll(containerSelector));

    this.setUpsellItems = function() {
      this.upsellItems = this.containers.map(container => {
        return Array.from(container.querySelectorAll(selectors.upsellItem));
      });
    }

    // show the first item, hide the rest
    this.showFirstUpsellItem = function() {
      this.upsellItems.forEach(itemList => {
        itemList.forEach((item, index) => {
          if (index == 0) {
            item.classList.remove('hide');
          } else {
            item.classList.add('hide');
          }
        });
      });
      status.currentIndex = 0;
    }

    this.showNextUpsellItem = function() {
      this.upsellItems.forEach((itemList, itemListIndex) => {
        var statusCurrentIndex = status.currentIndex;
        itemList[statusCurrentIndex].classList.add('hide');
        ++statusCurrentIndex;
        if (statusCurrentIndex < itemList.length) {
          itemList[statusCurrentIndex].classList.remove('hide');
        } else {
          this.containers[itemListIndex].classList.add('hide');
        }
      });
      ++status.currentIndex;
    };

    this.setUpsellItems();

    this.upsellItems.forEach(itemList => {
      itemList.forEach(item => {
        var acceptItem = item.querySelector(selectors.acceptItem);
        acceptItem.addEventListener('click', this.addUpsellItem.bind(this));
        var rejectItem = item.querySelector(selectors.rejectItem);
        rejectItem.addEventListener('click', this.skipUpsellItem.bind(this));
      });
    });

    // remove items already in cart
    theme.cart.getCart().then(cart => {
      return cart.items.map(item => item.variant_id.toString());
    }).then(variantIdsInCart => {
      this.upsellItems.forEach(itemList => {
        itemList.forEach(item => {
          if (variantIdsInCart.includes(item.dataset.productVariantId)) {
            item.remove();
          }
        });
      });
      // update the variable otherwise the deleted elements remain there
      this.setUpsellItems();
    }).then(() => {
      this.showFirstUpsellItem();
    });
  };

  UpsellProductForm.prototype = Object.assign({}, UpsellProductForm.prototype, {
    addUpsellItem: function(evt, callback) {
      evt.preventDefault();

      if (status.loading) {
        return;
      }

      var clickedButton = evt.currentTarget;

      // Loading indicator on add to cart button
      clickedButton.classList.add('btn--loading');

      status.loading = true;

      var payload = {
        items: [
          {
            id: clickedButton.dataset.productVariantId,
            quantity: 1
          }
        ]
      };
      fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: JSON.stringify(payload),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(function(data) {
        if (data.status === 422) {
          this.error(data);
        } else {
          var product = data;
          this.success(product);
        }

        status.loading = false;
        clickedButton.classList.remove('btn--loading');

        // Reload page if adding product from a section on the cart page
        if (document.body.classList.contains('template-cart')) {
          window.scrollTo(0, 0);
          location.reload();
        } else {
          this.showNextUpsellItem();
        }
      }.bind(this));
    },

    skipUpsellItem: function(evt, callback) {
      evt.preventDefault();
      this.showNextUpsellItem();
    },

    success: function(product) {
      this.containers.forEach(container => {
        var errors = container.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
      });

      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    },

    error: function(error) {
      if (!error.description) {
        console.warn(error);
        return;
      }

      this.containers.forEach(container => {
        var errors = container.querySelector('.errors');
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement('div');
        errorDiv.classList.add('errors', 'text-center');
        errorDiv.textContent = error.description;
        container.append(errorDiv);
      });

      document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: {
          errorMessage: error.description
        }
      }));
    }
  });

  return UpsellProductForm;
})();

var upsell = new theme.UpsellProduct('.cart-drawer-upsell');